import { gridColumnProps } from "../../../layouts/gridLayout";

export const headerFormGridColumnProps = {
    ...gridColumnProps,
    xs: 12,
    md: 12,
    lg: 4,
};
